import React from "react";
import { Target } from "lucide-react";
import { useI18n } from "@/context/I18nContext";
import Seo from "@/components/Seo";
import AdminEditableImage from "@/components/AdminEditableImage";
import { pageTitle } from "@/lib/seo";
import { useSiteContent, scValue } from "@/hooks/useSiteContent";

const About = () => {
  const { t, lang } = useI18n();
  const sc = useSiteContent();
  const pa = sc?.page_about;
  const v = (base, tkey) => scValue(pa, base, lang, t(tkey));
  return (
    <div data-testid="about-page">
      <Seo title={pageTitle(v("title", "about.title"))} description={v("p1", "about.p1")} path="/chi-siamo" type="website" />
      <section className="bg-brand-navy text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16 md:py-20">
          <h1 className="text-4xl md:text-5xl font-extrabold font-heading tracking-tight">{v("title", "about.title")}</h1>
        </div>
      </section>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16 grid lg:grid-cols-2 gap-12 items-center">
        <div className="space-y-5 text-brand-navy/70 leading-relaxed text-lg">
          <p>{v("p1", "about.p1")}</p>
          <p>{v("p2", "about.p2")}</p>
          <p>{v("p3", "about.p3")}</p>
          <div className="mt-8 rounded-2xl bg-brand-electric/5 border border-brand-electric/20 p-6 flex items-start gap-4">
            <div className="h-11 w-11 rounded-xl bg-brand-electric/10 flex items-center justify-center text-brand-electric shrink-0"><Target className="h-6 w-6" /></div>
            <div>
              <h3 className="font-heading font-semibold text-brand-navy">{v("missionTitle", "about.missionTitle")}</h3>
              <p className="mt-1 text-brand-navy/70 text-base">{v("mission", "about.mission")}</p>
            </div>
          </div>
        </div>
        <div className="rounded-2xl overflow-hidden border border-brand-navy/10 aspect-[4/3] bg-brand-light">
          <AdminEditableImage as="img" imageKey="about_image" defaultSrc="/about-lsh.png" alt="LearnSphereHub"
            className="relative w-full h-full" imgClassName="w-full h-full object-contain" />
        </div>
      </div>
    </div>
  );
};

export default About;
